<template>
  <section class="mc-section">
    <div class="mc-container">
      <div class="mc-section__title">
        {{ data.name }}
      </div>
      <div class="mc-section__body">
        <div v-html="data.text"></div>
        <img v-if="data.images.length>0" :src="data.images[0].src" width="330" height="212" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>